/* smart-answer-card-body-generating.tsx generated by @compiled/babel-plugin v0.38.1 */
import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./smart-answer-card-body-generating.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl-next';
import { cx } from '@atlaskit/css';
import Image from '@atlaskit/image';
import { useIsReducedMotion } from '@atlaskit/motion';
import { fg } from '@atlaskit/platform-feature-flags';
import { Inline, Stack, Text } from '@atlaskit/primitives/compiled';
import Skeleton from '@atlaskit/skeleton';
import { useAIAnswerContext } from '../../../ai-answer-dialog/ai-answer-context';
import GeneratingAnimation from '../../../ai-answer-dialog/ai-answer-loading/generating-animation';
import { ReducedMotionRovoGeneratingAnimation, RovoGeneratingAnimation } from '../../../ai-answer-dialog/ai-answer-loading/rovo-generating-animation';
import { onAIAnswerLoadingDialogShown } from '../../../ai-answer-dialog/analytics';
import { useAnalytics } from '../../../common/controller/analytics/use-analytics';
import { QueryIntent } from '../../../constants';
import { messages } from '../../smart-answer-card/messages';
import RovoIcon from './assets/Rovo.svg';
var styles = {
  container: "_ca0qpxbi _19bvpxbi _4t3ibn52",
  containerNewSAINLoading: "_u5f3pxbi _19bvpxbi _ca0qpxbi _n3tdpxbi _4t3ibn52",
  inline: "_19bvu2gc _u5f3u2gc _4t3i1ylp",
  jiraNlToJqlCardHeightOverride: "_4t3iwigc",
  explicitQuestion: "_4t3i1edt"
};
export function SmartAnswerCardBodyGenerating(_ref) {
  var heightOverride = _ref.heightOverride,
    queryIntent = _ref.queryIntent;
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes,
    queryReasoning = _useAIAnswerContext.queryReasoning;
  var _useAnalytics = useAnalytics(),
    _useAnalytics2 = _slicedToArray(_useAnalytics, 1),
    fireAnalyticsEvent = _useAnalytics2[0];
  var isReducedMotion = useIsReducedMotion();
  var showNewSAINLoading = fg('kd_sain_rovo_loading');

  // TODO: Temporary function for TEAMEU - normalize reasoning strings by lowercasing first letter and removing trailing periods
  var normalizeReasoningString = function normalizeReasoningString(str) {
    if (!str) {
      return str;
    }
    var result = "".concat(str.charAt(0).toLowerCase()).concat(str.slice(1));
    // Remove trailing period if it exists
    if (result.endsWith('.')) {
      result = result.slice(0, -1);
    }
    return result;
  };
  useEffect(function () {
    fireAnalyticsEvent(onAIAnswerLoadingDialogShown(commonAttributes));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (showNewSAINLoading) {
    return /*#__PURE__*/React.createElement(Stack, {
      xcss: cx(styles.containerNewSAINLoading, heightOverride === 'jiraNlToJqlCard' && styles.jiraNlToJqlCardHeightOverride, queryIntent === QueryIntent.EXPLICIT_QUESTION && styles.explicitQuestion),
      space: "space.200"
    }, /*#__PURE__*/React.createElement(Inline, {
      space: 'space.100',
      xcss: styles.inline,
      alignBlock: "center"
    }, /*#__PURE__*/React.createElement(Image, {
      src: RovoIcon,
      alt: ""
    }), /*#__PURE__*/React.createElement(Inline, null, /*#__PURE__*/React.createElement(Text, {
      color: 'color.text.subtle'
    }, queryReasoning ? /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.smart_answer_card_rovo_generating, {
      values: {
        queryReasoning: normalizeReasoningString(queryReasoning)
      }
    })) : /*#__PURE__*/React.createElement(FormattedMessage, messages.smart_answer_card_rovo_is_thinking)), isReducedMotion ? /*#__PURE__*/React.createElement(ReducedMotionRovoGeneratingAnimation, null) : /*#__PURE__*/React.createElement(RovoGeneratingAnimation, null))), /*#__PURE__*/React.createElement(Skeleton, {
      width: "100%",
      height: "16px",
      color: "var(--ds-skeleton-subtle, #17171708)"
    }), /*#__PURE__*/React.createElement(Skeleton, {
      width: "100%",
      height: "16px",
      color: "var(--ds-skeleton-subtle, #17171708)"
    }), /*#__PURE__*/React.createElement(Skeleton, {
      width: "90%",
      height: "16px",
      color: "var(--ds-skeleton-subtle, #17171708)"
    }));
  }
  return /*#__PURE__*/React.createElement(Inline, {
    xcss: cx(styles.container, heightOverride === 'jiraNlToJqlCard' && styles.jiraNlToJqlCardHeightOverride, queryIntent === QueryIntent.EXPLICIT_QUESTION && styles.explicitQuestion),
    space: "space.050"
  }, /*#__PURE__*/React.createElement(GeneratingAnimation, null), /*#__PURE__*/React.createElement(Text, {
    color: "color.text.subtlest"
  }, queryReasoning ? queryReasoning : /*#__PURE__*/React.createElement(FormattedMessage, messages.smart_answer_card_generating)));
}